import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import { isLoggedIn, currentUser } from '../service/user'
import { can } from '../mixins/permission'
import VueConfirmDialog from 'vue-confirm-dialog'
import vSelect from 'vue-select'

Vue.use(VueRouter)
Vue.use(VueConfirmDialog)
Vue.component('v-select', vSelect)

const roleRedirect = {
    translator: 'language.index'
}

const redirectTo = (role) => {
    return roleRedirect[role] || 'dashboard'
}

const routePermission = (to, from, next) => {

    const role = currentUser().role

    if (!can(to.meta.permission, to.meta.module)) {
        return next({name: redirectTo(role)})
    }

    return next()
}

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('../views/Dashboard.vue'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'dashboard'
        }
    },
    {
        path: '/users/users',
        name: 'user.index',
        component: () => import('../views/user/Index'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'user'
        }
    },
    {
        path: '/users/guests',
        name: 'user.guest',
        component: () => import('../views/user/guest'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'user'
        }
    },
    {
        path: '/users/create',
        name: 'user.create',
        component: () => import('../views/user/Form'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'user'
        }
    },
    {
        path: '/users/:id',
        name: 'user.edit',
        component: () => import('../views/user/Form'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'user'
        }
    },
    {
        path: '/users/payout/:id',
        name: 'user.payout',
        component: () => import('../views/user/Payout'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'user'
        }
    },
    {
        path: '/users/:id/order-list',
        name: 'user.order-list',
        component: () => import('../views/user/Order'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'user'
        }
    },
    {
        path: '/quizzes/quiz',
        name: 'quizzes.quiz.index',
        component: () => import('../views/quizzes/quiz/Index'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'quiz'
        }
    },
    {
        path: '/quizzes/quiz/create',
        name: 'quizzes.quiz.create',
        component: () => import('../views/quizzes/quiz/Form'),
        beforeEnter: routePermission,
        meta: {
            permission: 'create',
            module: 'quiz'
        }
    },
    {
        path: '/quizzes/quiz/:id',
        name: 'quizzes.quiz.edit',
        component: () => import('../views/quizzes/quiz/Form'),
        beforeEnter: routePermission,
        meta: {
            permission: 'edit',
            module: 'quiz'
        }
    },
    {
        path: '/quizzes/user/quiz/:id',
        name: 'quizzes.quiz-user.edit',
        component: () => import('../views/quizzes/quiz/Form'),
        beforeEnter: routePermission,
        meta: {
            permission: 'edit',
            module: 'quiz'
        }
    },
    {
        path: '/quizzes/quiz/:id/questions',
        name: 'quizzes.quiz.questions',
        component: () => import('../views/quizzes/quiz/Questions'),
        beforeEnter: routePermission,
        meta: {
            permission: 'edit',
            module: 'quiz'
        }
    },
    {
        path: '/quizzes/quiz/:id/log',
        name: 'quizzes.quiz.logs',
        component: () => import('../views/quizzes/quiz/Logs')
    },
    {
        path: '/quizzes/user',
        name: 'quizzes.user.index',
        component: () => import('../views/quizzes/user/Index'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'quiz'
        }
    },
    {
        path: '/quizzes/user/:id/questions',
        name: 'quizzes.user.questions',
        component: () => import('../views/quizzes/quiz/Questions'),
        beforeEnter: routePermission,
        meta: {
            permission: 'edit',
            module: 'quiz'
        }
    },
    {
        path: '/quizzes/user/:id/log',
        name: 'quizzes.user.logs',
        component: () => import('../views/quizzes/quiz/Logs')
    },
    {
        path: '/questions',
        name: 'questions.index',
        component: () => import('../views/questions/Index'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'question'
        }
    },
    {
        path: '/questions/preview',
        name: 'questions.preview',
        component: () => import('../views/questions/PreviewQuestion'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'question'
        }
    },
    {
        path: '/tag',
        name: 'tag.index',
        component: () => import('../views/tag/Index'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'tag'
        }
    },
    {
        path: '/result-message',
        name: 'result-message.index',
        component: () => import('../views/result-message/Index'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'quiz'
        }
    },
    {
        path: '/setting',
        name: 'setting.index',
        component: () => import('../views/setting/Index'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'setting'
        }
    },
    {
        path: '/language',
        name: 'language.index',
        component: () => import('../views/language/Index'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'language'
        }
    },
    {
        path: '/language/form/:lang/translation-messages',
        name: 'language.form',
        component: () => import('../views/language/Form'),
        beforeEnter: routePermission,
        meta: {
            permission: 'edit',
            module: 'language'
        }
    },
    {
        path: '/language/form/:lang/translation-result-messages',
        name: 'language.form-result-messages',
        component: () => import('../views/language/FormResultMessages'),
        beforeEnter: routePermission,
        meta: {
            permission: 'edit',
            module: 'language'
        }
    },
    {
        path: '/language/form/:lang/translation-onboarding',
        name: 'language.form-onboarding',
        component: () => import('../views/language/FormOnboarding'),
        beforeEnter: routePermission,
        meta: {
            permission: 'edit',
            module: 'language'
        }
    },
    {
        path: '/orders/:type',
        name: 'orders.index',
        component: () => import('../views/order/Index'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'order'
        }
    },
    {
        path: '/orders/:type/pending',
        name: 'orders.orderPending',
        component: () => import('../views/order/OrderPending'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'order'
        }
    },
    {
        path: '/quizzes/approval',
        name: 'quizzes.approval.index',
        component: () => import('../views/quizzes/approval/Index'),
        beforeEnter: routePermission,
        meta: {
            permission: 'edit',
            module: 'quiz'
        }
    },
    {
        path: '/quizzes/pending-approval',
        name: 'quizzes.wait.approval.index',
        component: () => import('../views/quizzes/wait-approval/Index'),
        beforeEnter: routePermission,
        meta: {
            permission: 'edit',
            module: 'quiz'
        }
    },
    {
        path: '/quizzes/approval/:id/questions',
        name: 'quizzes.approval.questions',
        component: () => import('../views/quizzes/quiz/Questions'),
        beforeEnter: routePermission,
        meta: {
            permission: 'edit',
            module: 'quiz'
        }
    },
    {
        path: '/quizzes/pending-approval/:id/questions',
        name: 'quizzes.pending-approval.questions',
        component: () => import('../views/quizzes/quiz/Questions'),
        beforeEnter: routePermission,
        meta: {
            permission: 'edit',
            module: 'quiz'
        }
    },
    {
        path: '/page',
        name: 'page.index',
        component: () => import('../views/page/Index'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'page'
        }
    },
    {
        path: '/page/create',
        name: 'page.create',
        component: () => import('../views/page/Form'),
        beforeEnter: routePermission,
        meta: {
            permission: 'create',
            module: 'page'
        }
    },
    {
        path: '/page/:id',
        name: 'page.edit',
        component: () => import('../views/page/Form'),
        beforeEnter: routePermission,
        meta: {
            permission: 'edit',
            module: 'quiz'
        }
    },
    {
        path: '/blog',
        name: 'blog.index',
        component: () => import('../views/blog/Index'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'blog'
        }
    },
    {
        path: '/blog/create',
        name: 'blog.create',
        component: () => import('../views/page/Form'),
        beforeEnter: routePermission,
        meta: {
            permission: 'create',
            module: 'blog'
        }
    },
    {
        path: '/blog/:id',
        name: 'blog.edit',
        component: () => import('../views/page/Form'),
        beforeEnter: routePermission,
        meta: {
            permission: 'edit',
            module: 'blog'
        }
    },
    {
        path: '/log/',
        name: 'log.index',
        component: () => import('../views/log/Index'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'log'
        }
    },
    {
        path: '/coupons/:type',
        name: 'coupons.index',
        component: () => import('../views/coupon/Index'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'coupon'
        }
    },
    {
        path: '/campaigns',
        name: 'campaigns.index',
        component: () => import('../views/coupon-campaign/Index'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'campaign'
        }
    },
    {
        path: '/school',
        name: 'school.index',
        component: () => import('../views/school/Index'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'school'
        }
    },
    {
        path: '/school/:id',
        name: 'school.user',
        component: () => import('../views/school/User'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'school'
        }
    },
    {
        path: '/school/:id/quizzes',
        name: 'school.quiz',
        component: () => import('../views/school/Quiz'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'school'
        }
    },
    {
        path: '/school/:id/quizzes/:quizId',
        name: 'school.quiz.detail',
        component: () => import('../views/quizzes/quiz/Questions'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'school'
        }
    },
    {
        path: '/subject-list',
        name: 'school.subject-list',
        component: () => import('../views/school/SubjectList'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'school'
        }
    },
    {
        path: '/quiz-list',
        name: 'school.quiz-list',
        component: () => import('../views/school/QuizList'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'school'
        }
    },
    {
        path: '/request-to-plus',
        name: 'school.request-to-plus',
        component: () => import('../views/school/RequestToPlusList'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'school'
        }
    },
    {
        path: '/teachers-request',
        name: 'school.teachers-request',
        component: () => import('../views/school/TeachersRequestList'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'school'
        }
    },
    {
        path: '/school-users-inactive',
        name: 'school.users-inactive',
        component: () => import('../views/school/Inactive'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'school'
        }
    },
    {
        path: '/school-districts',
        name: 'school-districts.index',
        component: () => import('../views/school-district/Index'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'school_district'
        }
    },
    {
        path: '/school-districts/:id',
        name: 'school-districts.id',
        component: () => import('../views/school-district/SchoolList'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'school_district'
        }
    },
    {
        path: '/front-page-widget',
        name: 'front-page-widget.index',
        component: () => import('../views/front-page/HomePage'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'front_page'
        }
    },
    {
        path: '/school-page-widget',
        name: 'school-page-widget.index',
        component: () => import('../views/front-page/SchoolPage'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'front_page'
        }
    },
    {
        path: '/affiliate/partners',
        name: 'affiliate.partners',
        component: () => import('../views/user/Index'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'affiliate'
        }
    },
    {
        path: '/affiliate/payout/pendings',
        name: 'payout.pending',
        component: () => import('../views/payout/Pending'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'affiliate'
        }
    },
    {
        path: '/affiliate/payout/settings',
        name: 'payout.setting',
        component: () => import('../views/payout/Setting'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'affiliate'
        }
    },
    {
        path: '/affiliate/payout/:type',
        name: 'payout.payout-pending',
        component: () => import('../views/payout/PayoutPending'),
        beforeEnter: routePermission,
        meta: {
            permission: 'view',
            module: 'affiliate'
        }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
    const publicPath = ['/login']
    const authRequired = !publicPath.includes(to.path)

    if (publicPath.includes(to.path) && isLoggedIn()) {
        return next('/dashboard')
    }

    if (to.name === 'home' && isLoggedIn()) {
        return next('/dashboard')
    }

    if (authRequired && !isLoggedIn()) {
        return next('/login')
    }

    next()
})

export default router
